var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.bClass,attrs:{"to":_vm.to,"title":_vm.text}},[(_vm.icon)?[_c('icon',{attrs:{"name":_vm.icon,"size":_vm.size}})]:_vm._e(),_vm._v(" "),(_vm.text)?[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }